<app-progressbar *ngIf="showSpinner"></app-progressbar>
<div class="backgroundLogin"></div>
<div class="loginForm">
    <h2 [innerHtml]="'RESET_PASSWORD' | translate">Reset your password</h2>
    <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">

        <mat-form-field>
            <input matInput [placeholder]="'NEW_PASSWORD' | translate"  type="password" formControlName="new_password" required>
            <mat-error *ngIf="submitted && f.new_password.errors && f.new_password.errors.required">{{'NEW_PASSWORD_FORM_ERROR_REQUIRED' | translate}}
            </mat-error>
            <mat-error *ngIf="submitted && f.new_password.errors && f.new_password.errors.minlength">{{'NEW_PASSWORD_FORM_ERROR_LENGTH' | translate}}
            </mat-error>
        </mat-form-field>

        <mat-form-field>
            <input matInput [placeholder]="'CONFIRM_PASSWORD' | translate" type="password" formControlName="confirm_password" required
                   value="">
            <mat-error *ngIf="submitted && f.confirm_password.errors && f.confirm_password.errors.required">{{'CONFIRM_PASSWORD_FORM_ERROR_REQUIRED' | translate}}
            </mat-error>
            <mat-error *ngIf="submitted && f.confirm_password.errors && f.confirm_password.errors.minlength">{{'CONFIRM_PASSWORD_FORM_ERROR_LENGTH' | translate}}
            </mat-error>

        </mat-form-field>
        <div class="loginFormBottom">
            <button [disabled]="loading" class="btn btn-outline-light">
                <app-progressbar *ngIf="loading"></app-progressbar>
                {{'RESET_PASSWORD' | translate}}
            </button>

        </div>


    </form>
</div>

